import React from "react";
import { usePage } from "@inertiajs/react";
import styled from "styled-components";
import { GlobalStyle } from "../constants/global-style";
import ProvideLoggedInUser from "../providers/ProvideLoggedInUser";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import ToastProvider from "../commons/Toast";
import ProvideLandingSearch from "../providers/ProvideLandingSearch";
import PortalSubNav from "./PortalSubNav";
import PortalHero from "./PortalHero";
import { dark } from "../constants/styles";

export default function PortalApp({ children }) {
  const { theme = "light", active, tabs, user, subscription, completeness } =
    usePage().props;
  const resolved = theme === "dark" ? "dark" : "light";

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
    return () => document.documentElement.removeAttribute("data-theme");
  }, [resolved]);

  return (
    <ProvideLandingSearch>
      <ToastProvider>
        <GlobalStyle />
        <ProvideLoggedInUser>
          <Page data-theme={resolved}>
            <Header />
            <PortalHero
              user={user}
              subscription={subscription}
              completeness={completeness}
            />
            <PortalSubNav active={active} tabs={tabs} />
            <Body key={active}>{children}</Body>
            <Footer />
          </Page>
        </ProvideLoggedInUser>
      </ToastProvider>
    </ProvideLandingSearch>
  );
}

const Page = styled.div`
  background: #f9fafb;
  min-height: 100vh;
  color: #1f2937;
  font-family: "Montserrat", sans-serif;

  &[data-theme="dark"] {
    background: ${dark.page_bg};
    color: ${dark.text_primary};
  }
`;

const Body = styled.main`
  padding: 32px 0 64px;
  animation: portalFadeIn 200ms ease-out;

  @keyframes portalFadeIn {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 1023px) {
    padding: 24px 0 48px;
  }
`;
